module.exports = __webpack_public_path__ + "img/galery17.9b9b1f96.jpg";